import { makeStyles } from '@material-ui/core'
import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { loadGoogleMapApis } from 'shared/helpers/loadGoogleMapApis'
import { v4 as uuidv4 } from 'uuid'

import truckIcon from 'assets/images/truck.svg'
import { GOOGLE_APIS_LOADED } from 'helpers/constants'
import { getFormattedDate } from 'helpers/utils'
import { LoadStop, LocationVector } from 'models/jobs'
import { getLoggedInUserIdentityWithCache } from '../../api/identity'

interface Props {
  currentStop: LoadStop
  latestLocationVector: LocationVector
}

const useStyles = makeStyles({
  iconLabel: {
    backgroundColor: 'white',
    padding: '10px',
    borderRadius: '5px',
  },
})

const setGoogleApisLoaded = () => {
  return {
    type: GOOGLE_APIS_LOADED,
  }
}

const MapComponent = ({ currentStop, latestLocationVector }: Props) => {
  const classes = useStyles()
  const googleApisLoaded = useSelector((state: any) => state.googleApi.googleApisLoaded)
  const dispatch = useDispatch()
  const elementId = `map-${uuidv4()}`

  useEffect(() => {
    // This is a both public and private page
    // On private pages google maps are not initialized automatically
    if (!googleApisLoaded) {
      getLoggedInUserIdentityWithCache().then(({ web_google_api_key }) => {
        loadGoogleMapApis(
          web_google_api_key,
          () => {
            dispatch(setGoogleApisLoaded())
          },
          true
        )
      })
    }
  }, [googleApisLoaded, dispatch])

  useEffect(() => {
    if (googleApisLoaded) {
      const google = window.google
      let map = new google.maps.Map(document.getElementById(elementId)!, {
        scrollwheel: true,
        zoom: 14,
        draggable: true,
        mapTypeControl: false,
        streetViewControl: false,
        zoomControlOptions: {
          position: google.maps.ControlPosition.TOP_RIGHT,
          // @ts-ignore
          style: google.maps.ZoomControlStyle.LARGE,
        },
      })

      const bounds = new google.maps.LatLngBounds()

      if (latestLocationVector) {
        const locationDriver = new google.maps.LatLng(
          latestLocationVector.latitude,
          latestLocationVector.longitude
        )
        const formattedDate = getFormattedDate(latestLocationVector.timestamp, currentStop.location_timezone)
        const driverMarker = new google.maps.Marker({
          map,
          position: locationDriver,
          icon: {
            url: truckIcon,
            labelOrigin: new google.maps.Point(10, -20),
          },
          label: {
            text: formattedDate,
            className: classes.iconLabel,
          },
        })
        bounds.extend(driverMarker.getPosition()!)
      }

      const locationCurrentStop = new google.maps.LatLng(currentStop.location_lat, currentStop.location_long)
      const currentLoadStopMarker = new google.maps.Marker({
        map,
        position: locationCurrentStop,
        label: currentStop.sequence_number.toString(),
      })
      bounds.extend(currentLoadStopMarker.getPosition()!)
      map.fitBounds(bounds)
    }
  }, [latestLocationVector, classes, googleApisLoaded, currentStop, dispatch, elementId])

  return <div style={{ width: '100%', height: 400 }} id={elementId} />
}

export default MapComponent
